import View from '@app/Events/View'
import Subscription from '@app/Events/Subscription'
import SubscriptionForAnonim from '@app/Events/SubscriptionForAnonim'

export default function install(Vue) {
  Vue.component(View.name, View)
  Vue.component(Subscription.name, Subscription)
  Vue.component(SubscriptionForAnonim.name, SubscriptionForAnonim)
}
